import moment from 'moment'

export default {
  /*
  * number of days to warn of an expired license
  * typically used to generate table class 'warning'
  */
  WARN_DAYS: 10,

  /*
  * Calculate a license expiry date, based on the activation date,
  * license expiry date, and duration.  One of expiry date and duration
  * are requred.
  *
  * activationDate - 2016-11-08T22:49:42.855Z
  * expiryDate - 2016-01-30T12:00:00-0700 or null
  * duration - 45 or 0 (days)
  *
  * returns a momentjs date when the license has expired
  */
  licenseExpiryDate (activationDate, expiryDate, duration) {
    var durationExpirationDate, expiresExpirationDate
    var expirationDate = null

    duration = Number(duration)
    if (duration === 0 && !expiryDate) {
      throw new Error('unexpected license with no duration or expiry date set!')
    }

    if (expiryDate) {
      expiresExpirationDate = moment(expiryDate)
    }
    if (duration && duration !== 0) {
      durationExpirationDate = moment(activationDate).add(duration, 'days')
    }

    if (expiryDate && duration && duration !== 0) {
      expirationDate = durationExpirationDate.isBefore(expiresExpirationDate) ? durationExpirationDate : expiresExpirationDate
    } else if (expiryDate) {
      expirationDate = expiresExpirationDate
    } else {
      expirationDate = durationExpirationDate
    }

    return expirationDate
  }
}



// WEBPACK FOOTER //
// ./src/lib/license.js